"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mtCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var mtCountry = exports.mtCountry = function mtCountry(t) {
  return {
    id: 'MT',
    name: t('Malta'),
    flag: '🇲🇹',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[A-Z]{3}\s?[0-9]{4}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. VLT 1234 or VLT1234',
    phonePrefix: '356',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Malta',
    currency: 'EUR'
  };
};